module.exports = __webpack_public_path__ + "img/Icons_STORIES_WHITE.6435e34f.png";